import React from 'react';

import BaySpinner from '../BaySpinner';
import './BayFullPageLoader.scss';

interface BayFullPageLoaderProps {
	show?: boolean;
	id?: string;
	t: (_key: string) => string;
	loadingText?: React.ReactNode;
	spinnerSize?: number;
	spinnerVariant?: string;
	spinnerBorderWidth?: string;
	overlayClassName?: string;
	overlayStyle?: React.CSSProperties;
	contentClassName?: string;
	cardClassName?: string;
	cardStyle?: React.CSSProperties;
	loadingTextClassName?: string;
	spinnerClassName?: string;
}

const BayFullPageLoader = ({
	show = false,
	id,
	t,
	loadingText = t('loading'),
	spinnerSize = 54,
	spinnerVariant = 'primary',
	spinnerBorderWidth = '6px',
	overlayClassName,
	overlayStyle,
	contentClassName,
	cardClassName,
	cardStyle,
	loadingTextClassName,
	spinnerClassName,
}: BayFullPageLoaderProps) => {
	if (!show) {
		return null;
	}

	return (
		<div
			className={`bayFullPageLoader position-fixed top-0 start-0 ${overlayClassName || ''}`.trim()}
			id={id || 'bayFullPageLoader'}
			style={overlayStyle}
		>
			<div className={`d-flex justify-content-center align-items-center w-100 h-100 p-3 ${contentClassName || ''}`.trim()}>
				<div className={`bayFullPageLoaderCard d-flex flex-column align-items-center justify-content-center text-center rounded bg-white shadow p-5 ${cardClassName || ''}`.trim()} style={cardStyle}>
					<BaySpinner
						className={spinnerClassName}
						hideTitle
						size={spinnerSize}
						borderWidth={spinnerBorderWidth}
						variant={spinnerVariant}
					/>
					<div className={`bayFullPageLoaderText ${loadingTextClassName || ''}`.trim()}>{loadingText}</div>
				</div>
			</div>
		</div>
	);
};

export default BayFullPageLoader;
